import React, { useState } from "react";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Check your inbox" subtitle="If that email is registered, we've sent a reset link.">
        <div className="bg-white rounded-2xl border-2 border-border p-8 text-center">
          <CheckCircle2 size={48} className="mx-auto text-forest-700 mb-4" strokeWidth={2} />
          <p className="text-forest-700 text-lg">Open the email and follow the link to set a new password. The link expires in 1 hour.</p>
          <Link to="/login" className="inline-block mt-6 text-terracotta font-bold text-lg" data-testid="back-to-login">Back to log in</Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Forgot password?" subtitle="Enter your email and we'll send you a reset link.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="font-semibold text-forest-900 mb-1.5 block">Email</label>
          <div className="relative">
            <Mail size={22} className="absolute left-4 top-1/2 -translate-y-1/2 text-forest-500" strokeWidth={2.5} />
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full min-h-[56px] text-lg pl-12 pr-4 rounded-xl border-2 border-border focus:border-terracotta focus:ring-4 focus:ring-terracotta/20 outline-none bg-white" placeholder="you@example.com" />
          </div>
        </div>
        <button type="submit" disabled={busy} data-testid="forgot-submit"
          className="w-full min-h-[56px] rounded-full bg-terracotta text-white font-bold text-lg hover:bg-terracotta-dark transition-transform active:scale-95 disabled:opacity-60">
          {busy ? "Sending…" : "Send reset link"}
        </button>
      </form>
      <Link to="/login" className="flex items-center gap-2 text-forest-700 font-semibold mt-6" data-testid="back-to-login">
        <ArrowLeft size={20} strokeWidth={2.5} /> Back to log in
      </Link>
    </AuthShell>
  );
}
